import { useState, useEffect } from "react";
import { SeoTag, CxenseParseTag } from "../../../components/seo/SeoTag";
import MultimediaPage from "../../../components/multimedia/MultimediaPage";
// import styles from "./styles/homepage/Home.module.scss";

const Multimedia = () => {
  const [url, setUrl] = useState("");
  const title = "2022 Philippine elections | Videos, shows, podcasts, multimedia";
  const description =
    "List of Rappler shows, videos, podcasts and multimedia you can watch or listen to about the 2022 Philippine elections";
  const keywords =
    "2022 Philippine elections, #PHVote, 2022 Philippine national elections";
  const og_image = "https://www.rappler.com/tachyon/2022/03/ATIN-PILIPINAS.jpg";

  let twitter_title;
  useEffect(() => {
    setUrl(window.location.href);
    twitter_title = `2022 Philippine elections - Multimedia #PHVote #WeDecide ${window.location.href}`;
  }, []);
  return (
    <>
      <SeoTag
        title={title}
        description={description}
        keywords={keywords}
        og_image={og_image}
        twitter_og_image={og_image}
        twitter_title={twitter_title}
        twitter_description={description}
      />
      <CxenseParseTag title={title} />
      <MultimediaPage url={url} />
    </>
  );
};

export default Multimedia;
